<div class="container">
  <div class="page-container">
    <div class="title-bar">
      <div class="dashboard-title">Site Dashboard</div>
    </div>

    <mat-divider class="divider-top"></mat-divider>

    <div class="subtitle-row">
      <div class="left-section">
        <div class="total-sites">{{ startIndex }} - {{ endIndex }} of {{ totalItems }} Total Carbon Sites</div>
        <div class="pagination-select table-container">
          <mat-form-field>
            <mat-select (selectionChange)="goToPage(1)" [(value)]="paginationTotal" class="select-filter">
              <mat-option [value]="20">20 Per page</mat-option>
              <mat-option [value]="40">40 Per page</mat-option>
              <mat-option [value]="100">100 Per page</mat-option>
              <mat-option [value]="99999">Show All</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <div class="terminated-filter">
            <mat-checkbox
              #showTerminated
              (change)="applyShowTerminatedFilter($event, 'show_terminated')"
              value="true"
              [checked]="filterValues.show_terminated"
              class="show-terminated">
              Show Terminated
            </mat-checkbox>
          </div>
          <div class="terminated-filter">
            <mat-checkbox
              #assignedToMe
              (change)="applyAssignedToMeFilter($event, 'assigned_to_me')"
              value="true"
              [checked]="filterValues.assigned_to_me"
              class="show-terminated">
              Assigned to Me
            </mat-checkbox>
          </div>
        </div>
        <div
          (click)="clearFilters()"
          [className]="
            this.getBaseQueryString() === this.getFullQueryString() ? 'clear-filter disabled-filter' : 'clear-filter'
          ">
          Clear All Filters
        </div>
      </div>
      <div class="right-section">
        <div class="select-instruction">Select at least one row to enable bulk controls</div>
        <mat-form-field class="field bulk-actions">
          <mat-select (selectionChange)="bulkAction($event)" placeholder="Bulk Actions">
            <mat-option [disabled]="!enableBulkStripeEmailButton" value="stripe">Send Stripe Email</mat-option>
            <mat-option [disabled]="!enableBulkSiteStateChangeButton" value="status">Change Site Status</mat-option>
            <mat-option [disabled]="!enableBulkPaySiteButton" value="pay">Pay Sites</mat-option>
            <mat-option [disabled]="!enableBulkCsvExport" value="csv">CSV Export</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <mat-divider class="divider-bottom"></mat-divider>
  </div>

  <div class="table-container">
    <table [dataSource]="dataSource" mat-table aria-describedby="List of Sites">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th scope="col" *matHeaderCellDef mat-header-cell class="checkbox-cell">
          <mat-checkbox
            (change)="$event ? masterToggle() : null"
            [aria-label]="checkboxLabel()"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
        </th>
        <td (click)="$event.stopPropagation()" *matCellDef="let row" class="checkbox-cell" mat-cell>
          <mat-checkbox
            (change)="$event ? selection.toggle(row) : null"
            (click)="$event.stopPropagation()"
            [aria-label]="checkboxLabel(row)"
            [checked]="selection.isSelected(row)"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="needsReview">
        <th scope="col" *matHeaderCellDef mat-header-cell class="small-column">
          <div>Needs Review</div>
          <mat-form-field>
            <mat-select
              (selectionChange)="applyNeedsReviewFilter($event, 'needs_review')"
              [(value)]="filterValues.needs_review"
              panelWidth=""
              class="select-filter">
              <mat-option [value]="">None</mat-option>
              <mat-option [value]="true">Yes</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td *matCellDef="let row" mat-cell class="small-column">
          @if (isLimitedAdmin ? row.limitedAdminNeedsReview : row.needsReview) {
            <div class="icon">
              <fa-icon [icon]="['far', 'exclamation-triangle']" class="red size-18"></fa-icon>
            </div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="submittedDate">
        <th scope="col" *matHeaderCellDef mat-header-cell class="medium-column">
          <div (click)="toggleMultiSort('submitted_date')" class="header-with-sort">
            <span>Submitted Date</span>
            <span [class]="sortBy['submitted_date']" class="sort-icon-container">
              <fc-sort-icon [column]="'submitted_date'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
            </span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell class="medium-column">
          {{ row.submittedDate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="approvedDate">
        <th scope="col" *matHeaderCellDef mat-header-cell class="medium-column">
          <div (click)="toggleMultiSort('approved_date')" class="header-with-sort">
            <span>Approved Date</span>
            <span [class]="sortBy['approved_date']" class="sort-icon-container">
              <fc-sort-icon [column]="'approved_date'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
            </span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell class="medium-column">
          {{ row.approvedDate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th scope="col" *matHeaderCellDef mat-header-cell class="large-column">
          <div (click)="toggleMultiSort('status')" class="header-with-sort">
            <span>Status</span>
            <span [class]="sortBy['status']" class="sort-icon-container">
              <fc-sort-icon [column]="'status'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
            </span>
          </div>
          <mat-form-field>
            <mat-select
              (closed)="applyStatusFilter()"
              [(value)]="filterValues.status"
              class="select-filter"
              multiple
              panelClass="status-panel"
              placeholder="Filter">
              <mat-option *ngFor="let status of statuses" [value]="status">
                {{ status }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td *matCellDef="let row" mat-cell class="large-column">
          {{ row.status }}
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th scope="col" *matHeaderCellDef mat-header-cell class="small-column">
          <div (click)="toggleMultiSort('id')" class="header-with-sort">
            <span>ID #</span>
            <span [class]="sortBy['id']" class="sort-icon-container">
              <fc-sort-icon [column]="'id'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
            </span>
          </div>
          <mat-form-field>
            <input
              #filterId
              (keyup)="applyFilter($event, 'id')"
              [(value)]="filterValues.id"
              class="filterInput"
              matInput />
          </mat-form-field>
        </th>
        <td *matCellDef="let row" mat-cell class="small-column">
          {{ row.id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="cohort">
        <th scope="col" *matHeaderCellDef mat-header-cell class="large-column">
          <div>Cohort</div>
          <mat-form-field>
            <mat-select
              (selectionChange)="applyFilter($event, 'cohort_id', 'eq')"
              [(value)]="filterValues.cohort_id"
              class="select-filter"
              placeholder="Filter"
              data-cy="cohort-filter">
              <mat-option>None</mat-option>
              <mat-option data-cy="filterable-cohorts" *ngFor="let cohort of cohorts" [value]="cohort.id">
                {{ cohort.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td *matCellDef="let row" mat-cell class="large-column">
          {{ row.cohort ? row.cohort.name : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th scope="col" *matHeaderCellDef mat-header-cell class="large-column">
          <div (click)="toggleMultiSort('name')" class="header-with-sort">
            <span>Site Name</span>
            <span [class]="sortBy['name']" class="sort-icon-container">
              <fc-sort-icon [column]="'name'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
            </span>
          </div>
          <mat-form-field>
            <input
              #filterName
              (keyup)="applyFilter($event, 'name')"
              [(value)]="filterValues.name"
              matInput
              placeholder="Filter" />
          </mat-form-field>
        </th>
        <td *matCellDef="let row" class="site-name large-column" mat-cell>
          {{ row.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="accountId">
        <th scope="col" *matHeaderCellDef mat-header-cell class="large-column">
          <div>Applicant</div>
          <mat-form-field>
            <input
              #filterOwner
              (keyup)="getSiteByNestedField($event, 'owner')"
              [(value)]="filterValues.owner"
              matInput
              placeholder="Filter" />
          </mat-form-field>
        </th>
        <td *matCellDef="let row" mat-cell class="large-column">
          <a
            (click)="$event.stopPropagation()"
            [routerLink]="['/admin/profile', row.account.user.id]"
            target="_blank"
            rel="noopener noreferrer">
            {{ row.account.user.getDisplayName() }}
          </a>
          <a
            (click)="$event.stopPropagation()"
            *ngIf="!isLimitedAdmin && !row.account.user.lastLogin"
            class="resend-invite"
            href="javascript:void(0)">
            Resend Invite
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="stripeStatus">
        <th scope="col" *matHeaderCellDef mat-header-cell class="small-column">
          <div>Stripe</div>
          <mat-form-field>
            <mat-select
              (selectionChange)="applyHasStripeFilter($event, 'user_has_stripe')"
              [(value)]="filterValues.user_has_stripe"
              panelWidth=""
              class="select-filter">
              <mat-option [value]="">None</mat-option>
              <mat-option [value]="true">Active</mat-option>
              <mat-option [value]="false">Not Active</mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td *matCellDef="let row" mat-cell class="small-column">
          <div
            *ngIf="row.cohort && row.account.user.hasStripe(row.cohort.buyerId); else showStripePlaceholder"
            class="icon">
            <fa-icon [icon]="['far', 'badge-dollar']" class="green"></fa-icon>
          </div>
          <ng-template #showStripePlaceholder>
            <div class="icon">
              <fa-icon [icon]="['far', 'triangle-exclamation']" class="orange size-20"></fa-icon>
            </div>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="delegate">
        <th scope="col" *matHeaderCellDef mat-header-cell class="large-column">
          <div>Delegate</div>
          <mat-form-field>
            <input
              #filterDelegate
              (keyup)="getSiteByNestedField($event, 'delegate')"
              [(value)]="filterValues.delegate"
              matInput
              placeholder="Filter" />
          </mat-form-field>
        </th>
        <td *matCellDef="let row" mat-cell class="large-column">
          <div *ngIf="row.account && row.account.user && row.account.user.delegate; else noDelegate">
            <span *ngIf="isLimitedAdmin">
              {{ row.account.user.delegate.getDisplayName() }}
            </span>
            <a
              (click)="$event.stopPropagation()"
              *ngIf="!this.isLimitedAdmin"
              [routerLink]="['/admin/profile', row.account.user.delegate.id]"
              target="_blank"
              rel="noopener noreferrer">
              {{ row.account.user.delegate.getDisplayName() }}
            </a>
          </div>
          <ng-template #noDelegate>
            <fa-icon [icon]="['fas', 'minus']"></fa-icon>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="region">
        <th scope="col" *matHeaderCellDef mat-header-cell class="large-column">
          <div>Region</div>
          <mat-form-field>
            <mat-select
              (selectionChange)="getItemByRegionId($event, 'region')"
              [(value)]="filterValues.region"
              class="select-filter"
              placeholder="Filter">
              <mat-option>None</mat-option>
              <mat-option *ngFor="let region of regions" [value]="region.id">
                {{ region.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td *matCellDef="let row" mat-cell class="large-column">
          <ng-container *ngIf="row.cohort && row.cohort.region; else showRegionMinus">
            {{ row.cohort.region.name }}
          </ng-container>
          <ng-template #showRegionMinus>
            <fa-icon [icon]="['fas', 'minus']"></fa-icon>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="area">
        <th scope="col" *matHeaderCellDef mat-header-cell class="small-column">
          <div (click)="toggleMultiSort('area')" class="header-with-sort">
            <span>Forested Acres</span>
            <span [class]="sortBy['area']" class="sort-icon-container">
              <fc-sort-icon [column]="'area'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
            </span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell class="small-column">
          {{ math.round(row.area) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="valuation">
        <th scope="col" *matHeaderCellDef mat-header-cell class="medium-column">
          <span>Max Annual Payment</span>
        </th>
        <td *matCellDef="let row" mat-cell class="medium-column">
          {{ getValuationDisplay(row) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="assignedAdmin">
        <th scope="col" *matHeaderCellDef mat-header-cell class="large-column">
          <div>Assigned Admin</div>
          <mat-form-field>
            <mat-select
              (selectionChange)="getItemByAssignedAdminId($event, 'assigned_admin_id')"
              [(value)]="filterValues.assigned_admin_id"
              class="select-filter"
              placeholder="Filter">
              <mat-option>None</mat-option>
              <mat-option *ngFor="let admin of admins" [value]="admin.id">
                {{ admin.getDisplayName() }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </th>
        <td *matCellDef="let row" mat-cell class="large-column">
          {{ row.assignedAdmin ? row.assignedAdmin.getDisplayName() : '' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="updated_at">
        <th scope="col" *matHeaderCellDef mat-header-cell class="medium-column">
          <div (click)="toggleMultiSort('updated_at')" class="header-with-sort">
            <span>Last Updated</span>
            <span [class]="sortBy['updated_at']" class="sort-icon-container">
              <fc-sort-icon [column]="'updated_at'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
            </span>
          </div>
        </th>
        <td *matCellDef="let row" mat-cell class="small-column">
          {{ row.updatedAt | date: 'yyyy-MM-dd' }}
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
      <tr
        (click)="clickRow($event, row)"
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="row.isTooBig || row.isTooSmall ? 'alert' : null"
        mat-row></tr>
    </table>
  </div>

  <fc-table-pagination
    [totalPages]="totalPages"
    (goToPage)="goToPage($event)"
    [currentPage]="currentPage"
    [showPages]="showPages"></fc-table-pagination>
</div>
